<template>
  <div class="avatar-box">
    <el-avatar :size="size=='small'?28:60" :src="(src||'').split('?')[0]+'?x-oss-process=image/resize,h_120,m_lfit'"></el-avatar>
    <!-- <el-image :src="src" fit="contain"></el-image> -->
    <div v-if="name" class="name">{{name}}</div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Avatar',
  props: {
    src: String,
    name: String,
    size: String
  },
  data(){
    return {
      
    }
  },
  methods:{
    
  } 
}
</script>

<style scoped lang="less">
.avatar-box{
  display: block;
  line-height: 0;
  // font-weight: 500;
  text-align: center;
  border-radius: 30px;
  position: relative;
  .name{
    line-height: 1.5;
    max-width:80px;
    margin: 0 auto;
    white-space:nowrap;/* 规定文本是否折行 */  
    overflow: hidden;/* 规定超出内容宽度的元素隐藏 */
    text-overflow: ellipsis;
  }
  .el-image{
    width:60px;
    height:60px;
    overflow: hidden;
  }
}
</style>
